//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteN from './expedienteNotas'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteN />
            </div>
        );
    }

}
export default Index;